import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-confirmation-box',
  templateUrl: './confirmation-box.component.html',
  styleUrls: ['./confirmation-box.component.scss']
})
export class ConfirmationBoxComponent implements OnInit {
  deleteConfirmMessage:string='';
  //custommessage: string;
  header: string;
  //ProceedButtonName: string;
  //TerminateButtonName: string;
  @Input() public Content: any;
  action: Subject<any> = new Subject();
  constructor(
    public modalRef: NgbActiveModal,
  ) { }

  ngOnInit() {
    if (this.Content.custommessage !== '' && this.Content.custommessage !== undefined)
      this.deleteConfirmMessage = this.Content.custommessage;
    else
      this.deleteConfirmMessage = "Selected Record(s) will be deleted. Do you want to proceed?";
    if (this.header === '' || this.header === undefined)
      this.header = "Confirmation Message";

      if (this.Content.ProceedButtonName === '' || this.Content.ProceedButtonName === undefined)
      this.Content.ProceedButtonName = "Ok";

      if (this.Content.TerminateButtonName === '' || this.Content.TerminateButtonName === undefined)
      this.Content.TerminateButtonName = "Cancel";
  }

  showConfirm(): void {
     ;
    this.modalRef.close();
    
  }
  CancelClcik(): void {
    this.modalRef.dismiss();
  }
 
}
